import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private subject = new Subject<any>();
  private subject1 = new Subject<any>();
  constructor() { }
  sendMessage(message: any) {
    this.subject.next(message);
    // console.log(message);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  cityChanged(city) {
    // console.log(city);
    this.subject1.next(city);
  }

  getCityChange() {
    return this.subject1.asObservable();
  }
}
